import api from "@/lib/axios";

export const getSupplyItems = async () => {
  const { data } = await api.get("/supply/items");
  return data.data;
};

export const createSupplyItem = async (payload) => {
  const { data } = await api.post("/supply/items", payload);
  return data.data;
};

export const updateSupplyItem = async (id, payload) => {
  const { data } = await api.patch(`/supply/items/${id}`, payload);
  return data.data;
};

export const deleteSupplyItem = async (id) => {
  const { data } = await api.delete(`/supply/items/${id}`);
  return data.data;
};

export const addStockMovement = async (payload) => {
  const { data } = await api.post("/supply/stock", payload);
  return data.data;
};

export const getStockMovements = async (itemId, params) => {
  const { data } = await api.get(`/supply/stock/${itemId}/movements`, {
    params,
  });
  return data.data;
};

export const getSupplyRequests = async () => {
  const { data } = await api.get("/supply/requests");
  return data.data;
};

export const getSupplyRequest = async (id) => {
  const { data } = await api.get(`/supply/requests/${id}`);
  return data.data;
};

export const createSupplyRequest = async (payload) => {
  const { data } = await api.post("/supply/requests", payload);
  return data.data;
};

export const updateSupplyRequest = async (id, payload) => {
  const { data } = await api.patch(`/supply/requests/${id}`, payload);
  return data.data;
};

export const getSupplyCategories = async () => {
  const { data } = await api.get("/supply/categories");
  return data.data;
};

export const createSupplyCategory = async (payload) => {
  const { data } = await api.post("/supply/categories", payload);
  return data.data;
};

export const updateSupplyCategory = async (id, payload) => {
  const { data } = await api.patch(`/supply/categories/${id}`, payload);
  return data.data;
};

export const deleteSupplyCategory = async (id) => {
  const { data } = await api.delete(`/supply/categories/${id}`);
  return data.data;
};
